/* eslint-disable */
import {ProductGuideStep} from './ProductGuideStep';
import {SectionBlock} from './SectionBlock';
/**
* @description Interface for Avensia.Commerce.Web.src.views.ContentPage.components.ProductGuideBlock
*/
export interface ProductGuideBlock extends SectionBlock {
	url: string;
	showHero: boolean;
	productCategories: string[];
	steps: ProductGuideStep[];
}
export const isProductGuideBlock = (model: unknown): model is ProductGuideBlock => (model as ProductGuideBlock).component === 'Bygghemma.Commerce.Web.src.views.ContentPage.components.ProductGuideBlock';

